import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsPerDomainWidgetComponent } from './tractors-per-domain-widget.component';
import {DashboardWidgetModule} from '../../dashboard-widget/dashboard-widget.module';
import {DxPieChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsPerDomainWidgetComponent],
    imports: [
        CommonModule,
        DashboardWidgetModule,
        DxPieChartModule
    ],
  exports: [TractorsPerDomainWidgetComponent]
})
export class TractorsPerDomainWidgetModule { }
